<script setup lang="ts">

import type NewsItem from "@/types/NewsItem.ts";
import ModalTrigger from "@/components/Interface/Modal/ModalTrigger.vue";
import { usePlayerRelationStore } from '@/stores/playerRelations.ts'
import PositionIcon from '@/components/Elements/Images/Icons/PositionIcon.vue'
import NewsItemBase from '@/components/Sections/News/Types/Base/NewsItemBase.vue'
import NewsItemBaseStructure from '@/components/Sections/News/Types/Base/NewsItemBaseStructure.vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const playerRelationStore = usePlayerRelationStore();

const props = defineProps<{
  newsItem: NewsItem,
  toast: boolean
}>();

</script>

<template>
  <NewsItemBase
    :toast="toast"
    :toast-image="props.newsItem.contentData.profileImage"
    :toast-text="t('news.types.newEmpireMet.toast', { player: props.newsItem.contentData.nickname })"
  >
    <ModalTrigger type="requestAudience" :data="{'relation': playerRelationStore.findRelationByPlayerId( props.newsItem.contentData.playerId)}" >
      <NewsItemBaseStructure
        :newsItem="props.newsItem"
        :item-image="props.newsItem.contentData.profileImage"
        :header="t('news.types.newEmpireMet.title', { player: props.newsItem.contentData.nickname })"
      >
        {{ t('news.types.newEmpireMet.body', { player: props.newsItem.contentData.nickname }) }} <PositionIcon @click.stop :x="props.newsItem.contentData.xPos" :y="props.newsItem.contentData.yPos"></PositionIcon><br>
      </NewsItemBaseStructure>
    </ModalTrigger>
  </NewsItemBase>
</template>

<style scoped lang="scss">

</style>